import { render, staticRenderFns } from "./ProjectGroupNewFormFrProject.vue?vue&type=template&id=10f5b5d1"
import script from "./ProjectGroupNewFormFrProject.vue?vue&type=script&lang=js"
export * from "./ProjectGroupNewFormFrProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports